import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './pages/login/login';
import JobSiteListPage from './pages/jobSiteList/jobSiteList';
import './styles/App.scss';
import Header from './pieces/header/header';
import Footer from './pieces/footer/footer';
import EmployeeList from './pages/employeeList/employeeList';
import ProtectedRoute from './guards/ProtectedRoute';
import MapPage from './pages/mapPage/mapPage';
import UserList from "./pages/userList/userList";
import DataList from "./pages/dataList/dataList";
import ProtectedRouteSuperAdmin from "./guards/ProtectedRouteSuperAdmin";
import CompaniesPage from "./pages/companyList/companyList";
import CompanyPage from "./pages/companyList/companyDetails";
import JobSiteDetailsPage from "./pages/jobSiteDetails/jobSiteDetails";
import ProtectedRouteAdmin from "./guards/ProtectedRouteAdmin";
import ReportsPage from "./pages/reports/reports";
import SettingsPage from "./pages/settings/settings";
import CheckinPage from "./pages/checkin/checkin";
import PrivacyPolicy from "./pages/privacyPolicy/privacyPolicy";
import TermsAndConditions from "./pages/termsAndConditions/termsAndConditions";
import JobSiteStats from "./pages/jobSiteStats/jobSiteStats";
import LoginTest from "./pages/loginTest/loginTest";
import AuthInitializer from './components/AuthInitializer';
import { useSelector } from 'react-redux';
import { RootState } from './store/store';

const DefaultRoute: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.role === 'SUPERADMIN') {
    return <Navigate to="/companies" />;
  }

  return <Navigate to="/map" />;
};

const App: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const isInitialized = useSelector((state: RootState) => state.user.isInitialized);

  return (
    <AuthInitializer>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/checkin/:jobSiteId/:todayDate/:foremanId" element={<CheckinPage />} />
            <Route path="/checkin/:jobSiteId/day/:todayDate/:foremanId" element={<CheckinPage />} />
          </Routes>
          {isInitialized && user && <Header />}
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/loginTest" element={<LoginTest />} />
            <Route path="/jobSites" element={<ProtectedRoute />}>
              <Route path="/jobSites/:jobSiteId" element={<JobSiteDetailsPage />} />
              <Route path="/jobSites" element={<JobSiteListPage />} />
            </Route>
            <Route path="/jobSiteStats" element={<ProtectedRoute />}>
              <Route index element={<JobSiteStats />} />
            </Route>
            <Route path="/employees" element={<ProtectedRoute />}>
              <Route path="/employees" element={<EmployeeList />} />
            </Route>
            <Route path="/map" element={<ProtectedRoute />}>
              <Route path="/map" element={<MapPage />} />
            </Route>
            <Route path="/users" element={<ProtectedRoute />}>
              <Route path="/users/:id?" element={<UserList />} />
            </Route>
            <Route path="/data" element={<ProtectedRoute />}>
              <Route path="/data/:id?" element={<DataList />} />
            </Route>
            <Route path="/companies" element={<ProtectedRouteSuperAdmin />}>
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/companies/:id?" element={<CompanyPage />} />
            </Route>
            <Route path="/reports" element={<ProtectedRouteAdmin />}>
              <Route path="/reports" element={<ReportsPage />} />
            </Route>
            <Route path="/settings" element={<ProtectedRouteAdmin />}>
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="/" element={<DefaultRoute />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthInitializer>
  );
};

export default App;
